module.exports = __webpack_public_path__ + "img/intermediary-head.b0d64add.png";